export enum ROOMS_STATUS {
  ACTIVATED = 'ACTIVATED',
  DEACTIVATED = 'DEACTIVATED',
}

export enum ROOMS_REFERENCE_SECTION {
  ROOMS = 'Rooms',
}

export enum ROOMS_REFERENCE_CATEGORIES {
  RESOURCES = 'Resources',
}

export enum ROOMS_REFERENCE_CATEGORY_FIELD {
  NAME = 'Name',
}
